export default __webpack_public_path__ + "static/media/talon.60b30d03.png";